module.exports = __webpack_public_path__ + "static/media/united-kingdom.a7fc19d7.png";